import { render, staticRenderFns } from "./b-end-privacy.vue?vue&type=template&id=9badceae&"
import script from "./b-end-privacy.vue?vue&type=script&lang=js&"
export * from "./b-end-privacy.vue?vue&type=script&lang=js&"
import style0 from "./b-end-privacy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports